export default __webpack_public_path__ + "static/media/b.ab88cd71.jpg";